/**
 * pin_keypad(비밀번호 자료 블록) 1회 시도 검증 액션.
 * 학생이 숫자를 입력할 때마다 호출해 서버에서 정오답을 즉시 피드백받는다.
 */
import api from "pages/api/axiosInstance";
import { PinAttemptRequest, PinAttemptResponse } from "./types";

interface BaseResponse<T> {
  isSuccess: boolean;
  code: number;
  message: string;
  result: T;
}

/**
 * pin_keypad 1회 시도 검증.
 * `POST /app/essay-learning/questions/{questionId}/blocks/{blockId}/pin-attempt`
 *
 * 에러를 throw 전파한다(자동저장과 다른 정책). 호출부가 400/403/404를 직접 분기해야 한다.
 * ★ 응답에 정답값 미포함(보안 불변식).
 */

export const postEssayPinAttempt = async (
  questionId: number,
  blockId: string,
  payload: PinAttemptRequest
): Promise<PinAttemptResponse> => {
  const res = await api.post<BaseResponse<PinAttemptResponse>>(
    `/app/essay-learning/questions/${questionId}/blocks/${encodeURIComponent(
      blockId
    )}/pin-attempt`,
    payload
  );
  return res.data.result;
};
